import { RouteRecordName, RouteRecordRaw } from 'vue-router';

/** Возвращает маршрут (из списка переданных) и название родительского маршрута, если искомый маршрут является дочерним. */
export const getRouteByName = (routes: RouteRecordRaw[], name: string): {
  parentRouteName?: RouteRecordName,
  route: RouteRecordRaw,
} | null => {
  for (let i = 0; i < routes.length; i++) {
    if (routes[i].name === name) return { route: routes[i] };

    if (routes[i].children?.length) {
      const route = getRouteByName(routes[i].children || [], name);

      if (route) {
        return {
          parentRouteName: route.parentRouteName || routes[i].name,
          route: route.route,
        };
      }
    }
  }

  return null;
};
